import apiConfig from "~~/src-tauri/api.json"

// The remote API's address — lives only in src-tauri/api.json, which the Rust side
// (src-tauri/build.rs → constants::API_BASE) reads too. scripts/check-api.mjs guards release builds.
export const API_BASE: string = apiConfig.apiBase
